import { useShallow } from 'zustand/react/shallow';

import { ConfirmationDialog } from '@/components/ui/confirmation-dialog';
import { useGlobalDialogStore } from '@/store/global-dialog/use-global-dialog-store';

export function GlobalDialog() {
  const { isOpen, title, description, actionText, onAction, closeDialog } = useGlobalDialogStore(
    useShallow(s => ({
      isOpen: s.isOpen,
      title: s.title,
      description: s.description,
      actionText: s.actionText,
      onAction: s.onAction,
      closeDialog: s.closeDialog,
    }))
  );

  const handleConfirm = () => {
    onAction?.();
  };

  return (
    <ConfirmationDialog
      confirmLabel={actionText}
      description={description}
      hideCancel
      onConfirm={handleConfirm}
      onOpenChange={open => {
        if (!open) {
          closeDialog();
        }
      }}
      open={isOpen}
      title={title}
    />
  );
}
